module.exports = __webpack_public_path__ + "static/media/3126361-uhd_3840_2160_25fps.e957e87e.mp4";